import { render, staticRenderFns } from "./matchSchedule.vue?vue&type=template&id=9d45feac&scoped=true"
import script from "./matchSchedule.vue?vue&type=script&lang=js"
export * from "./matchSchedule.vue?vue&type=script&lang=js"
import style0 from "./matchSchedule.vue?vue&type=style&index=0&id=9d45feac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d45feac",
  null
  
)

export default component.exports